import Model from '../Model'
import {toFormData} from "../../utils";

export default class RequestForMaterials extends Model {
    setAttributes(attributes) {
        super.setAttributes(attributes)
        let tokens = [
            attributes.requestedFor,
            attributes.packageReference,
            attributes.packageName,
            attributes.reference,
        ]
        this.tokens = tokens.join('|').toLowerCase();
    }

    static parseAttributes(attributes = {}) {
        attributes.package = attributes.package?.value
        return attributes
    }

    static async find(packageReference, id) {
        const data = await Http.get(route('api.v2.project-delivery.request-for-materials', {
            package_reference: packageReference,
            id
        }), {})
        return this.make(data)
    }

    static async all(packageReference = null) {
        const data = await Http.get(route('api.v2.project-delivery.request-for-materials.list', [packageReference]))
        return this.make(data)
    }

    static async create(packageReference, packageName, id) {
        const url = route('api.v2.project-delivery.request-for-materials.store', [packageReference, id])
        const o = await Http.post(url, toFormData({id: id, packageName: packageName}))
        return await this.find(packageReference, id)
    }

    async update(attributes = {}) {
        const url = route('api.v2.project-delivery.request-for-materials.store', {
            package_reference: this.packageReference,
            id: this.id
        })
        const payload = this.constructor.parseAttributes({...this.getFormAttributes(), ...attributes})
        const o = await Http.put(url, payload)
    }

    async submit() {
        await Http.post(route('api.v2.project-delivery.request-for-materials.submit', {
            package_reference: this.packageReference,
            id: this.id
        }))
    }

    async complete() {
        await Http.post(route('api.v2.project-delivery.request-for-materials.complete', {
            package_reference: this.packageReference,
            id: this.id
        }))
    }

    async acknowledge() {
        await Http.post(route('api.v2.project-delivery.request-for-materials.acknowledge', {
            package_reference: this.packageReference,
            id: this.id
        }))
    }

    async draft() {
        await Http.post(route('api.v2.project-delivery.request-for-materials.draft', {
            package_reference: this.packageReference,
            id: this.id
        }))
    }

    async refresh() {
        const data = await RequestForMaterials.find(this.packageReference, this.id)
        Object.assign(this, data)
    }

    async saveAndRefresh() {
        await this.update()
        await this.refresh()
    }

    async delete() {
        await Http.delete(route('api.v2.project-delivery.request-for-materials.delete', {
            package_reference: this.packageReference,
            id: this.id
        }))
    }
}
